// extracted by mini-css-extract-plugin
module.exports = {"filterRecapButton":"Chip_filterRecapButton__mLcbf"};